import React from 'react';
import {NavLink} from "react-router-dom";
import {LOGIN_ROUTE} from "../../util/Constants";

const ForgotPasswordForm = ({restorePassword, data, setData}) => {
    return (
        <div className="w-full max-w-md rounded-3xl border border-stone-200/70 bg-white/95 p-8 shadow-soft backdrop-blur-sm">
            <h2 className="text-2xl font-semibold tracking-tight text-bark-900">Восстановление пароля</h2>
            <div className="mt-6 flex flex-col gap-4">
                <div>
                    <label className="lut-label">Email</label>
                    <input
                        className="lut-input"
                        type="email"
                        placeholder="email"
                        value={data.email}
                        onChange={(e) => setData({...data, email: e.target.value})}
                        onKeyUp={(e => {
                            if (e.key === 'Enter') restorePassword()
                        })}
                    />
                </div>
                <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:items-center sm:justify-between">
                    <button type="button" onClick={restorePassword} className="lut-btn-pine">
                        Восстановить
                    </button>
                    <NavLink to={LOGIN_ROUTE} className="text-sm font-medium text-pine-700 hover:underline">Назад</NavLink>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
